import { Language, OrderPageData } from '../../api';

/**
 * Helper functions to manage step numbers dynamically based on disclaimers presence
 * This allows us to add the disclaimers step conditionally without breaking existing logic
 */

/**
 * Check if disclaimers step should be shown
 * Shows if disclaimers exist for the current language and has content
 */
export const shouldShowDisclaimersStep = (orderPage: OrderPageData, language: Language): boolean => {
  const { disclaimers } = orderPage;
  if (!disclaimers || !disclaimers[language]) {
    return false;
  }

  // Check if disclaimers content exists and is not empty (excluding HTML tags)
  const content = disclaimers[language];
  if (!content) {
    return false;
  }

  // Remove HTML tags and check if there's actual content
  const textContent = content.replace(/<[^>]*>/g, '').trim();
  return textContent.length > 0;
};

/**
 * Get the step number for personal details (always 2)
 */
export const getPersonalDetailsStepNumber = (): number => {
  return 2;
};

/**
 * Get the step number for disclaimers step (3 when shown)
 */
export const getDisclaimersStepNumber = (): number => {
  return 3;
};

/**
 * Get the step number for payment/final step
 * Returns 3 if no disclaimers, 4 if disclaimers are shown
 */
export const getPaymentStepNumber = (orderPage: OrderPageData, language: Language): number => {
  return shouldShowDisclaimersStep(orderPage, language) ? 4 : 3;
};

/**
 * Get the total number of steps
 */
export const getTotalSteps = (orderPage: OrderPageData, language: Language): number => {
  return shouldShowDisclaimersStep(orderPage, language) ? 5 : 4;
};
